import { Box } from '@mui/material';
import { DropDown, ChipInput, ChipInputTagErrors } from '@qrios/frontend-library';

import DateRangePicker from '../../../../../../common/fields/date-range-picker';
import { FiltersFormValues } from '../../../../../../common/reports/interfaces';
import { BILLING_STATUSES, FILTERS } from '../../../../../../common/filters/constants';

import locales from '../locales';
import { PayoutReportCreateForm } from '../interfaces';

interface Props extends FiltersFormValues<PayoutReportCreateForm> {}

const FiltersForm = ({ errors, touched, values, handleChange, handleBlur }: Props) => (
  <Box mt={2} mb={6}>
    <DateRangePicker
      from={{ name: FILTERS.FROM, value: values.from, error: errors.from, touched: touched.from }}
      to={{ name: FILTERS.TO, value: values.to, error: errors.to, touched: touched.to }}
      handleFromChange={value => handleChange(FILTERS.FROM, value)}
      handleToChange={value => handleChange(FILTERS.TO, value)}
      handleBlur={handleBlur}
    />
    <DropDown
      label={locales.filtersForm.statuses.label}
      placeholder={locales.filtersForm.statuses.placeholder}
      value={values.statuses}
      options={BILLING_STATUSES}
      name="statuses"
      handleChange={handleChange}
      handleBlur={handleBlur}
      multiple={true}
    />
    <ChipInput
      error={errors.operationIds?.[(errors.operationIds ?? []).length - 1]}
      label={locales.filtersForm.operationIds.label}
      value={values.operationIds}
      name="operationIds"
      handleChange={handleChange}
      handleBlur={handleBlur}
      placeholder={locales.filtersForm.operationIds.placeholder}
      tagErrors={errors.operationIds as ChipInputTagErrors}
    />
  </Box>
);

export default FiltersForm;
